// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/dashboard/v1/private/dashboard.proto" (package "c1.api.dashboard.v1.private", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetDashboardRequest
 */
export interface GetDashboardRequest {
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.DirectoryStateView
 */
export interface DirectoryStateView {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: bool directory_connected = 2;
     */
    directoryConnected: boolean;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.IntegrationsStateView
 */
export interface IntegrationsStateView {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: bool slack_integrated = 2;
     */
    slackIntegrated: boolean;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.TasksStateView
 */
export interface TasksStateView {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: bool task_created = 2;
     */
    taskCreated: boolean;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.AccessBundleStateView
 */
export interface AccessBundleStateView {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: bool bundle_created = 2;
     */
    bundleCreated: boolean;
    /**
     * @generated from protobuf field: bool bundle_has_applications = 3;
     */
    bundleHasApplications: boolean;
    /**
     * @generated from protobuf field: bool bundle_has_users = 4;
     */
    bundleHasUsers: boolean;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.DashboardView
 */
export interface DashboardView {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.DirectoryStateView directory_state = 2;
     */
    directoryState?: DirectoryStateView;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.IntegrationsStateView integrations_state = 3;
     */
    integrationsState?: IntegrationsStateView;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.TasksStateView tasks_state = 4;
     */
    tasksState?: TasksStateView;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.AccessBundleStateView access_bundle_state = 5;
     */
    accessBundleState?: AccessBundleStateView;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.CertifyTasks
 */
export interface CertifyTasks {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GrantTasks
 */
export interface GrantTasks {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.RevokeTasks
 */
export interface RevokeTasks {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.EnrollmentTasks
 */
export interface EnrollmentTasks {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.EntitlementGrants
 */
export interface EntitlementGrants {
    /**
     * @generated from protobuf field: int64 count_expiring = 1;
     */
    countExpiring: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetTasksOverviewRequest
 */
export interface GetTasksOverviewRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetTasksOverviewResponse
 */
export interface GetTasksOverviewResponse {
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.CertifyTasks certify_tasks = 1;
     */
    certifyTasks?: CertifyTasks;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.GrantTasks grant_tasks = 2;
     */
    grantTasks?: GrantTasks;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.RevokeTasks revoke_tasks = 3;
     */
    revokeTasks?: RevokeTasks;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.EnrollmentTasks enrollment_tasks = 4;
     */
    enrollmentTasks?: EnrollmentTasks;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetAccessOverviewRequest
 */
export interface GetAccessOverviewRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetAccessOverviewResponse
 */
export interface GetAccessOverviewResponse {
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.GrantTasks requests = 1;
     */
    requests?: GrantTasks;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.EntitlementGrants grants = 2;
     */
    grants?: EntitlementGrants;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetConflictsOverviewRequest
 */
export interface GetConflictsOverviewRequest {
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetConflictsOverviewResponse
 */
export interface GetConflictsOverviewResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetDashboardRequest$Type extends MessageType<GetDashboardRequest> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetDashboardRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetDashboardRequest
 */
export const GetDashboardRequest = new GetDashboardRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryStateView$Type extends MessageType<DirectoryStateView> {
    constructor() {
        super("c1.api.dashboard.v1.private.DirectoryStateView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "directory_connected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.DirectoryStateView
 */
export const DirectoryStateView = new DirectoryStateView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntegrationsStateView$Type extends MessageType<IntegrationsStateView> {
    constructor() {
        super("c1.api.dashboard.v1.private.IntegrationsStateView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "slack_integrated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.IntegrationsStateView
 */
export const IntegrationsStateView = new IntegrationsStateView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TasksStateView$Type extends MessageType<TasksStateView> {
    constructor() {
        super("c1.api.dashboard.v1.private.TasksStateView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "task_created", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.TasksStateView
 */
export const TasksStateView = new TasksStateView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessBundleStateView$Type extends MessageType<AccessBundleStateView> {
    constructor() {
        super("c1.api.dashboard.v1.private.AccessBundleStateView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bundle_created", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "bundle_has_applications", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "bundle_has_users", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.AccessBundleStateView
 */
export const AccessBundleStateView = new AccessBundleStateView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DashboardView$Type extends MessageType<DashboardView> {
    constructor() {
        super("c1.api.dashboard.v1.private.DashboardView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "directory_state", kind: "message", T: () => DirectoryStateView },
            { no: 3, name: "integrations_state", kind: "message", T: () => IntegrationsStateView },
            { no: 4, name: "tasks_state", kind: "message", T: () => TasksStateView },
            { no: 5, name: "access_bundle_state", kind: "message", T: () => AccessBundleStateView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.DashboardView
 */
export const DashboardView = new DashboardView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CertifyTasks$Type extends MessageType<CertifyTasks> {
    constructor() {
        super("c1.api.dashboard.v1.private.CertifyTasks", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.CertifyTasks
 */
export const CertifyTasks = new CertifyTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTasks$Type extends MessageType<GrantTasks> {
    constructor() {
        super("c1.api.dashboard.v1.private.GrantTasks", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GrantTasks
 */
export const GrantTasks = new GrantTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeTasks$Type extends MessageType<RevokeTasks> {
    constructor() {
        super("c1.api.dashboard.v1.private.RevokeTasks", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.RevokeTasks
 */
export const RevokeTasks = new RevokeTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnrollmentTasks$Type extends MessageType<EnrollmentTasks> {
    constructor() {
        super("c1.api.dashboard.v1.private.EnrollmentTasks", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.EnrollmentTasks
 */
export const EnrollmentTasks = new EnrollmentTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementGrants$Type extends MessageType<EntitlementGrants> {
    constructor() {
        super("c1.api.dashboard.v1.private.EntitlementGrants", [
            { no: 1, name: "count_expiring", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.EntitlementGrants
 */
export const EntitlementGrants = new EntitlementGrants$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTasksOverviewRequest$Type extends MessageType<GetTasksOverviewRequest> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetTasksOverviewRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetTasksOverviewRequest
 */
export const GetTasksOverviewRequest = new GetTasksOverviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTasksOverviewResponse$Type extends MessageType<GetTasksOverviewResponse> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetTasksOverviewResponse", [
            { no: 1, name: "certify_tasks", kind: "message", T: () => CertifyTasks },
            { no: 2, name: "grant_tasks", kind: "message", T: () => GrantTasks },
            { no: 3, name: "revoke_tasks", kind: "message", T: () => RevokeTasks },
            { no: 4, name: "enrollment_tasks", kind: "message", T: () => EnrollmentTasks }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetTasksOverviewResponse
 */
export const GetTasksOverviewResponse = new GetTasksOverviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessOverviewRequest$Type extends MessageType<GetAccessOverviewRequest> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetAccessOverviewRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetAccessOverviewRequest
 */
export const GetAccessOverviewRequest = new GetAccessOverviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessOverviewResponse$Type extends MessageType<GetAccessOverviewResponse> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetAccessOverviewResponse", [
            { no: 1, name: "requests", kind: "message", T: () => GrantTasks },
            { no: 2, name: "grants", kind: "message", T: () => EntitlementGrants }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetAccessOverviewResponse
 */
export const GetAccessOverviewResponse = new GetAccessOverviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConflictsOverviewRequest$Type extends MessageType<GetConflictsOverviewRequest> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetConflictsOverviewRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetConflictsOverviewRequest
 */
export const GetConflictsOverviewRequest = new GetConflictsOverviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConflictsOverviewResponse$Type extends MessageType<GetConflictsOverviewResponse> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetConflictsOverviewResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetConflictsOverviewResponse
 */
export const GetConflictsOverviewResponse = new GetConflictsOverviewResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.dashboard.v1.private.Dashboard
 */
export const Dashboard = new ServiceType("c1.api.dashboard.v1.private.Dashboard", [
    { name: "GetDashboardState", options: { "authz.method": { role: "VIEWER" } }, I: GetDashboardRequest, O: DashboardView },
    { name: "GetTasksOverview", options: { "authz.method": { role: "VIEWER" } }, I: GetTasksOverviewRequest, O: GetTasksOverviewResponse },
    { name: "GetAccessOverview", options: { "authz.method": { role: "VIEWER" } }, I: GetAccessOverviewRequest, O: GetAccessOverviewResponse },
    { name: "GetConflictsOverview", options: { "authz.method": { role: "VIEWER" } }, I: GetConflictsOverviewRequest, O: GetConflictsOverviewResponse }
]);
